import { create } from "zustand";

type ColorFilterType = {
    colorIds: Array<string>;
    toggleColorId: (id: string) => void;
    empty: () => void;
};

export const useColorFilter = create<ColorFilterType>()((set) => ({
    colorIds: [],
    toggleColorId: (id: string) =>
        set((state) => {
            const ids = [...state.colorIds];
            const index = ids.indexOf(id);
            if (index < 0) {
                ids.push(id);
                return { colorIds: ids };
            } else {
                const filtered = ids.filter((colorId) => colorId !== id);
                return { colorIds: filtered };
            }
        }),
    empty: () =>
        set(() => {
            return { colorIds: [] };
        }),
}));
